import { BaseContainerModel } from '../base-container.model';
import { app_tenant_hdr_RowClass } from '../../dbschema/app_tenant_hdr.model';

export class TenantHdrContainerModel extends BaseContainerModel {
  app_tenant_hdr: app_tenant_hdr_RowClass = new app_tenant_hdr_RowClass();
  owner_list: app_tenant_hdr_RowClass[] = [];
}